export const SET_GENERAL_STATISTICS = 'SET_GENERAL_STATISTICS';
export const CLEAR_GENERAL_STATISTICS = 'CLEAR_GENERAL_STATISTICS';
export const SET_PROJECT_STATISTICS = 'SET_PROJECT_STATISTICS';
export const CLEAR_PROJECT_STATISTICS = 'CLEAR_PROJECT_STATISTICS';
export const SET_CLOUD_SERVICES_STATISTICS = 'SET_CLOUD_SERVICES_STATISTICS';
export const CLEAR_CLOUD_SERVICES_STATISTICS = 'CLEAR_CLOUD_SERVICES_STATISTICS';
export const SET_PASSIVE_RISK_SCORE = 'SET_PASSIVE_RISK_SCORE';
export const CLEAR_PASSIVE_RISK_SCORE = 'CLEAR_PASSIVE_RISK_SCORE';
export const SET_RECALCULATION_IN_PROGRESS = 'SET_RECALCULATION_IN_PROGRESS';
export const CLEAR_RECALCULATION_IN_PROGRESS = 'CLEAR_RECALCULATION_IN_PROGRESS';
